import { renderHeaderTooltip } from '@utils/assessmentReportUtils'

import { Link } from '@suntex.core/nav'
import { Database_Procs_GetAlgebraGoalsMetricPlayers_Item } from '@suntex.fim/api-client'
import { CellCheckBox, ColumnType, HeaderCheckBox } from '@suntex.fim/ui'

/**
 * Common hidable column labels
 */
const commonHidableLabels = {
  algebraOverall: 'Algebra Overall',
  factFluency: 'Fact Fluency',
  equivalentFractions: 'Equivalent Fractions',
  fractions: 'Fractions',
  decimals: 'Decimals',
  integers: 'Integers',
  exponents: 'Exponents',
  orderOfOperations: 'Order Of Operations'
}

/**
 * Handles hidable columns list for players
 */
export const hidableSelectLabel: Record<string, string> = {
  playerName: 'Player Name',
  refName: 'Ref Name',
  ...commonHidableLabels
}

/**
 * Handles hidable columns list for schools
 */
export const schoolHidableSelectLabel: Record<string, string> = {
  teamName: 'Name',
  className: 'Class Name',
  ...commonHidableLabels
}

/**
 * Generates column definitions
 */
const generateColumns = (
  specificColumns: Record<string, { header: string; id: string }>
): ColumnType<Database_Procs_GetAlgebraGoalsMetricPlayers_Item>[] => {
  const commonColumns = Object.entries(commonHidableLabels).map(
    ([key, label]) => ({
      header: () => renderHeaderTooltip(label),
      id: key,
      accessorKey: key,
      size: 50
    })
  )

  const specificColumnsMapped = Object.entries(specificColumns).map(
    ([key, { header, id }]) => ({
      header: () => renderHeaderTooltip(header),
      id,
      accessorKey: key,
      size: 50,
      cell: (info) => {
        const userId = info.getValue() as string
        const redirectTo = `/player/${info.row.original?.playerId}/assessment-report/algebra-goals-metric`
        return id === 'playerName' ? (
          <Link className="table-player-name" to={redirectTo}>
            {userId}
          </Link>
        ) : (
          <b>{userId}</b>
        )
      }
    })
  )

  return [...specificColumnsMapped, ...commonColumns]
}

/**
 * Handles table column mapping for players
 */
export const columns =
  (): ColumnType<Database_Procs_GetAlgebraGoalsMetricPlayers_Item>[] => [
    {
      id: 'select',
      size: 50,
      enableResizing: false,
      enableSorting: false,
      header: HeaderCheckBox,
      cell: CellCheckBox
    },
    ...generateColumns({
      playerName: { header: 'Player Name', id: 'playerName' },
      refName: { header: 'Ref Name', id: 'refName' }
    })
  ]

/**
 * Handles table column mapping for schools
 */
export const schoolColumns =
  (): ColumnType<Database_Procs_GetAlgebraGoalsMetricPlayers_Item>[] =>
    generateColumns({
      teamName: { header: 'Team Name', id: 'teamName' },
      className: { header: 'Class Name', id: 'className' }
    })
